import axios from 'axios';
import { Logger } from 'emrn-hybrid/Logger';
import config from '../config';

/**
 * 积分中心获取转盘图片文字配置
 */
export async function getPZFromPoint(taskId: string): Promise<any> {
  const url = config.pointLink + 'GetLotteryRewardExtList?TaskId=' + taskId;
  const param = {
    method: 'get',
    url: url,
    timeout: 15 * 1e3,
  };
  return request(param);
}

function request(options: any) {
  console.log('%c [request]:', 'color: #3381e3', options);
  Logger.info({
    tag: '邀新活动',
    msg: `[积分中心获取转盘图片文字配置接口入参]: ${JSON.stringify(options)}`,
  });
  return new Promise((resolve, reject) => {
    axios(options)
      .then(res => {
        const status = res.status;
        if (status === 200) {
          console.log(`%c [response] ${options.url}: `, 'color: #ea5504', res.data);
          const { code, message } = res.data;
          Logger.info({
            tag: '邀新活动',
            msg: `[请求成功(${options.url})]: code=${code}, message=${message}`,
          });
          return resolve(res.data);
        } else {
          Logger.info({
            tag: '邀新活动',
            msg: `[请求失败(${options.url})]: status = ${status}`,
          });
          reject(status);
        }
      })
      .catch(error => {
        Logger.info({
          tag: '邀新活动',
          msg: `[请求失败(${options.url})]: ${error}`,
        });
        console.log(`[request on error]: ${error.stack}`);
        reject(error);
      });
  });
}
